<template>
  <div>
    <component
      :is="activeBoardConfiguration?.editComponent"
      v-if="!hideForm"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import JobEdit from '@/components/layouts/JobEdit.vue';
import OfferEdit from '@/components/layouts/OfferEdit.vue';
import ModelOfferEdit from '@/components/layouts/ModelOfferEdit.vue';
import Application from '@/components/layouts/Candidature.vue';
import Collaborator from '@/components/layouts/Candidate.vue';

export default {
  name: 'DynamicForm',
  components: { JobEdit, OfferEdit, Application, Collaborator, ModelOfferEdit },
  props: {
    mode: {
      type: String,
      default: null
    },
    uuid: {
      type: String,
      default: null
    }
  },
  data () {
    return { hideForm: false };
  },
  computed: {
    ...mapState([
      'activeBoardConfiguration'
    ]),
    isViewMode () {
      return this.mode === 'view';
    },
    headerTitle () {
      switch (this.mode) {
        case 'view':
          return `View ${this.contentType}`;
        case 'edit':
          return `Edit ${this.contentType}`;
        case 'create':
          return `Créer nouvelle ${this.contentType}`;
        default:
          return null;
      }
    }
  }
};
</script>
